import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { TextP } from '../../..';
import { IconType, DsiSvgIcon as SvgIcon } from '../General/SvgIcon';
import { FlexRow, FlexRowCenter } from '../../Defaults/Flexbox/Flexbox';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { FilterType } from './CategoryFilter';

interface Props {
  resetUrl: string;
  activeAttribs: any;
  onClickAttrib: any;
  theme: any;
}

function ActiveFilters({
  resetUrl,
  activeAttribs,
  onClickAttrib,
  theme,
}: Props) {
  return (
    <Wrapper>
      {Object.keys(activeAttribs).map(key => {
        const att = activeAttribs[key];
        const values = att.values;
        if (!values) {
          return (
            <ActiveFilterItem
              key={`${key}${att.attribName}`}
              text={`${att.attribName}: ${att.min} - ${att.max} ${
                att.unit ? att.unit : ''
              }`}
              // tslint:disable-next-line:jsx-no-lambda
              onClick={() =>
                onClickAttrib(FilterType.OPTIONS, {
                  attribId: key,
                  newValue: false,
                })
              }
            />
          );
        }

        return values.map(v => (
          <ActiveFilterItem
            key={`${key}${v.valueId}`}
            text={`${v.attribName}: ${v.name}`}
            // tslint:disable-next-line:jsx-no-lambda
            onClick={() =>
              onClickAttrib(FilterType.OPTIONS, {
                attribId: key,
                valueId: v.valueId,
                newValue: false,
              })
            }
          />
        ));
      })}

      {activeAttribs && Object.keys(activeAttribs).length > 0 && (
        <ResetFilterItem resetUrl={resetUrl} theme={theme} />
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  flex-flow: row wrap;
  overflow: auto;

  ${({ theme }) => theme.mediab.m580`
      flex-flow: row wrap;
  `}
`;

interface ActiveFilterItemProps {
  text: string;
  onClick: any;
}

function ActiveFilterItem({ text, onClick }: ActiveFilterItemProps) {
  return (
    <ActiveFilterItemWrapper onClick={onClick}>
      <RemoveFilterIcon
        icon={IconType.cross}
        width={16}
        height={16}
        viewBox="0 0 16 16"
        cursor="pointer"
        alt="Odstrániť filter"
        marginRight={8}
      />
      <Text>{text}</Text>
    </ActiveFilterItemWrapper>
  );
}

interface ResetItemProps {
  resetUrl: string;
  theme: any;
}

function ResetFilterItem({ resetUrl, theme }: ResetItemProps) {
  return (
    <ResetFilterItemWrapper to={resetUrl}>
      <ResetFilterIcon
        icon={IconType.cross}
        width={16}
        height={16}
        cursor="pointer"
        viewBox="0 0 16 16"
        title={__('Odstránenie všetkých filtrov')}
        alt={__('Odstránenie všetkých filtrov')}
        marginRight={8}
        fill={theme.colors.primary}
      />
      <ResetText>{__('Vymazať filter')}</ResetText>
    </ResetFilterItemWrapper>
  );
}

const ActiveFilterItemWrapper = styled(FlexRowCenter)`
  background: ${({ theme }) => theme.categoryFilter.activeBgColor};
  padding: ${rem(8)} ${rem(12)};
  height: ${rem(32)};
  border-radius: ${rem(2)};
  margin-right: ${rem(8)};
  margin-top: ${rem(8)};
  cursor: pointer;
`;

const ResetFilterItemWrapper = styled(Link)`
  padding: ${rem(8)} ${rem(12)};
  height: ${rem(32)};
  border-radius: ${rem(2)};
  margin-right: ${rem(8)};
  margin-top: ${rem(8)};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: row;
  background: none;
  cursor: pointer;
  text-decoration: none;
`;

const RemoveFilterIcon = styled(SvgIcon)`
  fill: ${({ theme }) => theme.categoryFilter.activeColor};
`;

const ResetFilterIcon = styled(SvgIcon)`
  fill: ${({ theme }) => theme.colors.primary} !important;
`;

const Text = styled(TextP)`
  color: ${({ theme }) => theme.categoryFilter.activeColor};
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.tertiary};
  line-height: ${rem(22)};
`;

const ResetText = styled(Text)`
  color: ${({ theme }) => theme.colors.primary};
`;

const WithTheme: any = withTheme(ActiveFilters);
export { WithTheme as ActiveFilters };
